/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StakeholderMarketPositioningMapViewPosition', 'model/StakeholderMarketPositioningMapViewPositionPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StakeholderMarketPositioningMapViewPosition'), require('../model/StakeholderMarketPositioningMapViewPositionPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StakeholderMarketPositioningMapViewPositionApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StakeholderMarketPositioningMapViewPosition, root.ForStractionServiceApi.StakeholderMarketPositioningMapViewPositionPaginationSlice);
  }
}(this, function(ApiClient, StakeholderMarketPositioningMapViewPosition, StakeholderMarketPositioningMapViewPositionPaginationSlice) {
  'use strict';

  /**
   * StakeholderMarketPositioningMapViewPosition service.
   * @module api/StakeholderMarketPositioningMapViewPositionApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StakeholderMarketPositioningMapViewPositionApi. 
   * @alias module:api/StakeholderMarketPositioningMapViewPositionApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionAddAllPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StakeholderMarketPositioningMapViewPosition>} body 
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.stakeholderMarketPositioningMapViewPositionAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewPositionAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionAddPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderMarketPositioningMapViewPosition} body 
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.stakeholderMarketPositioningMapViewPositionAddPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewPositionAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionDeleteAllPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewPositionDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewPositionDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionDeleteGet operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewPositionDeleteGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionDeleteGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling stakeholderMarketPositioningMapViewPositionDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionEditAllPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionEditAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StakeholderMarketPositioningMapViewPosition>} body 
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionEditAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewPositionEditAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionEditAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewPositionEditAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/editAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionEditPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderMarketPositioningMapViewPosition} body 
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.stakeholderMarketPositioningMapViewPositionEditPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewPositionEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionLoadGet operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderMarketPositioningMapViewPosition} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} positionID 
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderMarketPositioningMapViewPosition}
     */
    this.stakeholderMarketPositioningMapViewPositionLoadGet = function(_4SAPIAppID, positionID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionLoadGet";
      }

      // verify the required parameter 'positionID' is set
      if (positionID == undefined || positionID == null) {
        throw "Missing the required parameter 'positionID' when calling stakeholderMarketPositioningMapViewPositionLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'positionID': positionID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderMarketPositioningMapViewPosition;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionSearchPut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/StakeholderMarketPositioningMapViewPosition>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderMarketPositioningMapViewPosition} body 
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/StakeholderMarketPositioningMapViewPosition>}
     */
    this.stakeholderMarketPositioningMapViewPositionSearchPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewPositionSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [StakeholderMarketPositioningMapViewPosition];

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the stakeholderMarketPositioningMapViewPositionSearchSlicePut operation.
     * @callback module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionSearchSlicePutCallback
     * @param {String} error Error message, if any.
     * @param {module:model/StakeholderMarketPositioningMapViewPositionPaginationSlice} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchSlice
     * @param {String} _4SAPIAppID 
     * @param {module:model/StakeholderMarketPositioningMapViewPosition} body 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.startID  (default to 0)
     * @param {Integer} opts.maxCount  (default to 0)
     * @param {Integer} opts.slicingOrder  (default to 0)
     * @param {module:api/StakeholderMarketPositioningMapViewPositionApi~stakeholderMarketPositioningMapViewPositionSearchSlicePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/StakeholderMarketPositioningMapViewPositionPaginationSlice}
     */
    this.stakeholderMarketPositioningMapViewPositionSearchSlicePut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling stakeholderMarketPositioningMapViewPositionSearchSlicePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling stakeholderMarketPositioningMapViewPositionSearchSlicePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startID': opts['startID'],
        'maxCount': opts['maxCount'],
        'slicingOrder': opts['slicingOrder']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = StakeholderMarketPositioningMapViewPositionPaginationSlice;

      return this.apiClient.callApi(
        '/StakeholderMarketPositioningMapViewPosition/searchSlice', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
